const brandNameHe = () => window.Config?.brand_Name_HE ?? '';

export const packageList = [
  {
    offreID: 'fibber',
    isSelected: true,
    header: {
      text: '',
      isCounter: true,
      counterDate: new Date('2022-03-9T00:00:00'),
    },
    content: {
      get title() {
        return `פייבר 600 עם ${brandNameHe()} TV`;
      },
      price: {
        showStartFrom: true,
        price: '20',
        text: 'למשך חודשיים',
        lineUnderPrice: {
          price: '99',
          isOldPrice: false,
          text: 'לחודש לאחר מכן',
        },
        freeText: 'מחיר מיוחד לאתר',
      },
    },
    packageInfo: {
      title: 'עם טריפל פייבר תוכלו',
      features: [{text: 'להשתמש ב10 מכשירים בו זמנית בבית אחד'}, {text: 'להוריד סרטים/סדרות במהירות'}, {text: 'לשחק כמה משחקים במקביל'}],
      uploadSpeed: 60,
      downloadSpeed: 600,
      freeText: {
        text: 'נתב מתנה למצטרפים לאתר',
        icon: '',
      },
      fullDetailsLink: '',
      btnText: 'בחר במהירות זו',
    },
  },
  {
    offreID: 'tv',
    isSelected: false,
    header: {
      text: 'החבילה הפופולרית',
      isCounter: false,
      counterDate: new Date('2022-03-9T00:00:00'),
    },
    content: {
      title: 'פייבר 1GB',
      price: {
        showStartFrom: false,
        price: '134',
        text: '',
        lineUnderPrice: {
          price: '165',
          isOldPrice: true,
          text: 'לחודש',
        },
        freeText: 'מחיר מיוחד לאתר',
      },
    },
    packageInfo: {
      title: 'עם טריפל פייבר תוכלו',
      features: [{text: 'להשתמש ב10 מכשירים בו זמנית בבית אחד'}, {text: 'להוריד סרטים/סדרות במהירות'}, {text: 'לשחק כמה משחקים במקביל'}],
      uploadSpeed: 60,
      downloadSpeed: 600,
      freeText: {
        text: 'נתב מתנה למצטרפים לאתר',
        icon: '',
      },
      fullDetailsLink: '',
      btnText: 'בחר במהירות זו',
    },
  },
];


// export default packageList;